import { Card, Space, Tag, Typography } from 'antd'
import { useAnswer } from '../../contexts/AnswerContext'
import { useFormEditor } from '../../contexts/FormContext'

const { Text } = Typography

interface Props {}

export const EmployeeReadOnly = ({}: Props) => {
  const { employee } = useFormEditor()
  const { item, answer } = useAnswer()

  if (employee === undefined || item === undefined || answer === undefined)
    return <></>

  const answerContent = answer.employeeAnswer ? (
    answer.employeeAnswer
  ) : (
    <Space>
      {answer.employeeOptions &&
        answer.employeeOptions.map((option) => (
          <Tag key={option.id}>{option.name}</Tag>
        ))}
    </Space>
  )

  return (
    <Card styles={{ body: { padding: 10 } }}>
      <Text type="secondary">
        Réponse de {employee.firstName} : {answerContent}
      </Text>
    </Card>
  )
}

export type EmployeeReadOnlyType = { EmployeeReadOnly: typeof EmployeeReadOnly }
